export const currentDate = () => new Date();
